/** @jsx jsx */

import { Fragment } from 'react';

import { Text } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';
import { getAppUrl } from 'app/developer-v3/utils';

import TodosSimple from './TodosSimple';

type Props = {
  integrationId: number;
};

export default function TodosReview({ integrationId }: Props) {
  const integrationUrl = getAppUrl(integrationId);

  return (
    <Fragment>
      <Text margin="0px 0px 20px" tag="p">
        Once you submit, we’ll be in touch within 1 week to start the review
        process.
      </Text>
      <TodosSimple
        description={
          <Text>
            <Link href={integrationUrl}>Validate your integration</Link> to
            ensure you don’t have warnings or errors to work through first.
          </Text>
        }
        icon="alertCircleFill"
      />
      <TodosSimple
        description={
          <Text>
            Ensure all{' '}
            <Link
              href={`${BASE_DOC_URL_VB}/publish/integration-publishing-requirements`}
              target="_blank"
            >
              publishing requirements
            </Link>{' '}
            are met before you submit.{' '}
            <Link href="https://developer.zapier.com/contact" target="_blank">
              Contact support
            </Link>{' '}
            or use the{' '}
            <Link href="https://publishbot.zapier.app" target="_blank">
              PublishBot
            </Link>{' '}
            if you have any questions.
          </Text>
        }
        icon="alertCircleFill"
      />
    </Fragment>
  );
}
